import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(TextField)`
  flex: 1;
`;
